import { StripeEnv } from '../../util/enums';
import { StripeError } from './errors';
import { vaultRequest } from './request';

const CREATE_STRIPE_PERSON_MUTATION = `
mutation VaultStripePersonCreate(
  $vaultKycId: ID!,
  $stripeConnectAccountId: String!
  $stripeEnv: VaultStripeEnv
  ) {
  stripePersonId: vaultStripePersonCreate(
    stripeConnectAccountId: $stripeConnectAccountId,
    vaultKycId: $vaultKycId
    stripeEnv: $stripeEnv
  )
}
`;

const UPDATE_STRIPE_PERSON_MUTATION = `
mutation VaultStripePersonUpdate(
  $vaultKycId: ID!,
  $stripePersonId: String!,
  $stripeConnectAccountId: String!
  $stripeEnv: VaultStripeEnv
  ) {
  stripePersonId: vaultStripePersonUpdate(
    stripeConnectAccountId: $stripeConnectAccountId,
    stripePersonId: $stripePersonId,
    vaultKycId: $vaultKycId
    stripeEnv: $stripeEnv
  )
}
`;

const DELETE_STRIPE_PERSON_QUERY = `
mutation VaultStripePersonDelete(
  $stripeConnectAccountId: String!,
  $stripePersonId: String!,
  $stripeEnv: VaultStripeEnv
  ) {
  vaultStripePersonDelete(
    stripeConnectAccountId: $stripeConnectAccountId,
    stripePersonId: $stripePersonId,
    stripeEnv: $stripeEnv
    )
}`;

const GET_INVALID_REPRESENTATIVE_QUERY = `
query VaultStripeInvalidRepresentative($stripeConnectAccountId: ID!, $stripeEnv: VaultStripeEnv) {
  vaultStripeInvalidRepresentative(stripeConnectAccountId: $stripeConnectAccountId, stripeEnv: $stripeEnv)
}`;

export const createStripePerson = async (
  vaultKycId: string,
  stripeConnectAccountId: string,
  stripeEnv?: StripeEnv,
): Promise<string> => {
  const stripePersonIdRes = await vaultRequest(CREATE_STRIPE_PERSON_MUTATION, {
    vaultKycId,
    stripeConnectAccountId,
    stripeEnv,
  });
  const stripePersonAccountIdResJson = await stripePersonIdRes.json();
  if (
    stripePersonAccountIdResJson.errors &&
    stripePersonAccountIdResJson.errors.length > 0
  ) {
    throw new StripeError(
      'Failed to create Stripe Person',
      stripePersonAccountIdResJson.errors[0],
    );
  }
  return stripePersonAccountIdResJson.data.stripePersonId;
};

export const updateStripePerson = async (
  vaultKycId: string,
  stripeConnectAccountId: string,
  stripePersonId: string,
  stripeEnv?: StripeEnv,
): Promise<string> => {
  const stripePersonIdRes = await vaultRequest(UPDATE_STRIPE_PERSON_MUTATION, {
    vaultKycId,
    stripeConnectAccountId,
    stripePersonId,
    stripeEnv,
  });
  const stripePersonAccountIdResJson = await stripePersonIdRes.json();
  if (
    stripePersonAccountIdResJson.errors &&
    stripePersonAccountIdResJson.errors.length > 0
  ) {
    throw new StripeError(
      'Failed to update Stripe Person',
      stripePersonAccountIdResJson.errors[0],
    );
  }
  return stripePersonAccountIdResJson.data.stripePersonId;
};

export const deleteStripePerson = async (
  stripePersonId: string,
  stripeConnectAccountId: string,
  stripeEnv?: StripeEnv,
): Promise<void> => {
  await vaultRequest(DELETE_STRIPE_PERSON_QUERY, {
    stripeConnectAccountId,
    stripePersonId,
    stripeEnv,
  });
};

export const getInvalidRepresentativeId = async (
  stripeConnectAccountId: string,
  stripeEnv?: StripeEnv,
): Promise<string | undefined> => {
  const res = await vaultRequest(GET_INVALID_REPRESENTATIVE_QUERY, {
    stripeConnectAccountId,
    stripeEnv,
  });
  const resJson = await res.json();
  return resJson?.data?.vaultStripeInvalidRepresentative || undefined;
};
